import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Hero from "../../components/layout/Hero";
import {
  BCPArrowRightFromBracket,
  BCPSearch,
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
// import PostGallery from "../../components/utilities/PostGallery";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const useStyles = makeStyles((theme) => ({
  hoverOpacImage: {
    height: "120%",
    // maxWidth: "65%",
    opacity: "0.2",
    position: "absolute",
    bottom: "-10%",
    transform: "rotate(-5deg)",
    right: "-125px",
    "@media (max-width: 500px)": {
      right: "-200px",
    },
  },
}));

export default function HomeBanana() {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  return (
    <>
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <Hero
          backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/home1.jpg`}
          sxBackground={{
            height: ["unset", "70vh"],
            maxHeight: ["unset", "600px"],
            // minHeight: "unset",
          }}
        />

        <img
          src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/BannerLogo.png`}
          className={classes.hoverOpacImage}
          alt=""
        />

        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            "margin-left": "auto",
            "margin-right": "auto",
          }}
        >
          <Box
            sx={{
              pt: 8,
              pb: 6,
              height: "100%",
              width: "100%",
              textAlign: "center",
              display: "flex",
              flexFirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Container maxWidth={"sm"} sx={{ p: 1 }}>
              <Typography variant="h1" align="left" color="inherit" paragraph>
                Start a Bananagrams School Club
              </Typography>
              <Typography
                variant="body1"
                align="left"
                color="inherit"
                paragraph
              >
                {`With the inclusive Bananagrams School Kit, starting a club is possible for any school—whether public or private, with or without access to advanced resources like the internet or computers.`}
              </Typography>
              <Typography
                variant="body1"
                align="left"
                color="inherit"
                paragraph
                // fontWeight="700"
              >
                {`Ready to Build Your School Club?`}
              </Typography>

              <Box>
                <Grid container spacing={2} justifyContent="left">
                  <Grid item>
                    <Button
                      href="/play/events"
                      variant="contained"
                      color="primary"
                      startIcon={<BCPSearch />}
                    >
                      Enter Now
                    </Button>
                  </Grid>
                  {!authContext?.authState?.isAuthenticated && (
                    <Grid item>
                      <Button
                        href="/login"
                        variant="contained"
                        color="secondary"
                        startIcon={<BCPArrowRightFromBracket />}
                      >
                        Login
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
      <FeaturedEvents />
      <HighlightedEvents />

      <Hero
        sxBackground={{
          height: ["unset", "60vh", "60vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          background: `url('${SYSTEM_IMAGES_CLOUDFRONT}/images/home2.jpg') center top/auto no-repeat`,
        }}
        maxWidth="md"
      >
        <Grid
          container
          sx={{
            pl: [3, 8],
            pr: [3, 8],
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Starting a Bananagrams School Club is Easy!
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Follow these simple steps to get your Bananagrams School Club up
              and running:
            </Typography>

            <Typography variant="body1" align="left" color="inherit">
              1. Register Your Club
            </Typography>
            <Typography variant="body1" align="left" color="inherit">
              2. Teach Tournament Mode
            </Typography>
            <Typography variant="body1" align="left" color="inherit">
              3. Access Free Resources
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              4. Host a Tournament
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Start your club now!
            </Typography>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        sxBackground={{
          height: ["unset", "60vh", "50vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          background: `url('${SYSTEM_IMAGES_CLOUDFRONT}/images/home3.jpg') center center/auto no-repeat`,
        }}
        maxWidth="md"
      >
        <Grid
          container
          sx={{
            pl: [3, 8],
            pr: [3, 8],
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Bananagrams School Kit
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              {`The Bananagrams School Kit is your key to quickly launching a successful School Club. Designed to equip school staff with everything they need, the kit offers guidance on teaching the game and introducing competitive play. It includes enhanced rules known as Bananagrams Tournament Mode, specifically created for a more structured and exciting competitive environment.`}
            </Typography>

            <Typography variant="body1" align="left" color="inherit" paragraph>
              Get Your School Kit Today!
            </Typography>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        sxBackground={{
          height: ["unset", "60vh", "50vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          background: `url('${SYSTEM_IMAGES_CLOUDFRONT}/images/home4.jpg') center center/auto no-repeat`,
        }}
        maxWidth="md"
      >
        <Grid
          container
          sx={{
            pl: [3, 8],
            pr: [3, 8],
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              The Structure of the Bananagrams School League
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              {`The Bananagrams School League operates through multiple competitive layers, giving students the chance to grow their skills and climb the rankings:`}
            </Typography>

            <Typography variant="body1" align="left" color="inherit">
              - School Club Tournaments
            </Typography>
            <Typography variant="body1" align="left" color="inherit">
              - District Leagues
            </Typography>
            <Typography variant="body1" align="left" color="inherit">
              - Regional Tournaments
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              - National Tournaments
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Ready to Compete on Every Level?
            </Typography>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        sxBackground={{
          height: ["unset", "60vh", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          background: `url('${SYSTEM_IMAGES_CLOUDFRONT}/images/home5.jpg') center bottom/auto no-repeat`,
        }}
        maxWidth="md"
      >
        <Grid
          container
          sx={{
            pl: [3, 8],
            pr: [3, 8],
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Bananagrams League Rankings
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              {`Our ranking approach will resemble the ELO system used in chess, allowing for a fair assessment of player skills. Players will earn ranking points by defeating opponents with higher rankings, ensuring continuous improvement over time. This system not only fosters healthy competition but also ensures that rankings are permanent, following players even if they transition to a National League outside of the school system.`}
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Become a Part of the Ranking System!
            </Typography>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
